import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  iframeCirculerLoader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 18px)",
    "& .MuiCircularProgress-root": {
      color: theme?.palette?.primary2TextColor?.main
    }
  },
  iframeWrap: {
    position: "relative",
    margin: "0px 0 0px",
    minHeight: "calc(100vh - 126px)",
    display: "flex",
    // marginTop: "110px",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      // marginRight: "10px",
      margin: "20px 0 0",
      minHeight: "calc(100vh - 41px)"
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "60px",
      marginBottom: "10px",
      minHeight: "100%"
    },
    "& .MuiGrid-container": {
      padding: "0 6px",
      // maxWidth: "1350px",
      [theme.breakpoints.up("xl")]: {
        // maxWidth: "1450px",
      }
    }
  },
  gameCloseBtn: {
    width: "15px"
  },
  gameWrap: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100%",
    minWidth: "100%"
    // marginTop: "55px"
  },
  backBtn: {
    position: "absolute",
    left: "10px",
    top: "0px",
    zIndex: "2",
    padding: "5px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "14px",
    margin: "10px 0",
    "& img,svg": {
      marginRight: "5px",
      transform: "rotate(180deg)",
      filter: "invert(1)"
    },
    [theme.breakpoints.down("md")]: {
      background: "transparent",
      top: "0",
      color: theme?.palette?.primaryText?.[100],
      padding: "0"
    }
  },
  iframeContent: {
    width: "100%",
    borderRadius: "6px 0 6px 6px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50%",
    overflow: "hidden",
    position: "relative",
    paddingRight: "30px",
    [theme.breakpoints.up("xl")]: {
      height: "100%"
    },
    [theme.breakpoints.between("600", "900")]: {
      height: "calc(100vh - 124px) !important",
      marginTop: "100px !important"
    },

    "& iframe": {
      borderRadius: "5px",
      background: theme?.palette?.primaryBG?.[500],
      border: "none"
    },
    [theme.breakpoints.down("xl")]: {
      paddingRight: "0",
      marginLeft: "0",
      height: "100%"
    }
    // [theme.breakpoints.down("md")]: {
    //   height: "calc(100vh - 56px)",
    // },
  },
  iframeBtnWrap: {
    position: "absolute",
    display: "flex",
    flexFlow: "column",
    right: "0px",
    top: "0",
    "& .MuiButtonBase-root": {
      padding: "10px 5px",
      background: theme?.palette?.primaryBG?.[500],
      borderRadius: "0",
      minWidth: "30px",
      "& img,svg": {
        width: "12px"
      }
    },
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  iframeGameCard: {
    cursor: "pointer",
    borderRadius: "10px",
    overflow: "hidden",
    height: "180px",
    marginBottom: "10px",
    "& img,svg": {
      width: "100%",
      height: "100%"
    },
    [theme.breakpoints.down("md")]: {
      margin: "10px"
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px"
    }
  },
  favIconWrap: {
    "& img,svg": {
      width: "16px !important",
      height: "16px"
    }
  }
  // iframecontainer: {
  //   marginTop: "100px",
  // },
}));
